import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import mobileColumnCountAtom from './mobileColumnCountAtom';
const useToggleMobileColumnCount = () => {
  const $ = _c(2);
  const setMobileColumnCount = useSetAtom(mobileColumnCountAtom);
  let t0;
  if ($[0] !== setMobileColumnCount) {
    t0 = () => {
      setMobileColumnCount(_temp);
    };
    $[0] = setMobileColumnCount;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleMobileColumnCount = t0;
  return toggleMobileColumnCount;
};
export default useToggleMobileColumnCount;
function _temp(prevMobileColumnCount) {
  return prevMobileColumnCount === "1" ? "2" : "1";
}